import { RoutePoint } from "../../../models/routes/routePoint";
import ListItemCard from "../../../components/containers/listItemCard";
import clsx from "clsx";
import RoutePointInfo from "../routePointInfo";

const SimplePoint: React.FC<{ pointClosed: boolean; routePoint: RoutePoint }> = ({ pointClosed, routePoint }) => (
    <ListItemCard className={clsx("border-start border-5", pointClosed ? "border-success" : "border-warning")}>
        <RoutePointInfo routePoint={routePoint} />
    </ListItemCard>
);

export default SimplePoint;
